import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import { connect } from "react-redux";
import Switcher from "./switcher";
const mapStateToProps = (state) => ({
    routingPageKey: state[REDUX_ROUTING_PAGE_NAMESPACE].key
});
export default connect(mapStateToProps)(Switcher);
